
import { Component, Vue, Watch } from 'vue-facing-decorator'
import OrderList from './com/order-list.vue'
import AmountLogList from './com/amount-log-list.vue'
import ScoreLogList from './com/score-log-list.vue'
import CouponList from './com/coupon-list.vue'
import ChooseCoupon from './com/choose-coupon.vue'
import AdjustAmount from './com/adjust-amount.vue'
import AdjustScore from './com/adjust-score.vue'
import PaidVip from './com/paid-vip.vue'
import { getPaidVipText } from '@/common/vip'

@Component({
  components: {
    OrderList,
    AmountLogList,
    ScoreLogList,
    CouponList,
  }
})
export default class extends Vue {

  postData: any = null;
  loading = false;
  /** order | amount | score */
  activeTab = "order";

  get userId() {
    return this.$route.query.id;
  }

  /**
   * 预设等级是「保底」不是「封顶」：实际等级仍按累计积分算，
   * 算出结果低于预设时以预设为准。口径和用户列表那个按钮完全一致
   */
  async setPresetLevel() {
    let levelData: any;
    try {
      levelData = await this.$chooseVipGroup({
        multiple: false,
      });
    } catch (e) {
      // 用户取消
      return;
    }
    let { error, message } = await this.$post("/manager/level/set-user-preset-level", {
      levelId: levelData.id,
      id: this.postData.id,
    });
    if (error) return this.$error(message);
    this.$success("设置成功");
    this.getData();
  }

  async sendPaidVip() {
    try {
      await this.$dialog({
        title: "赠送付费会员",
        props: {
          width: "520px",
        },
        content: () => {
          /** postData 带了 paidLevelInfo / paidExpireTime，弹窗自己算得出当前等级和能不能换档 */
          return <PaidVip data={this.postData}></PaidVip>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }
    this.$success("赠送成功");
    this.getData();
  }

  async cancelPaidVip() {
    try {
      await this.$confirm("确定回收该用户的付费会员吗？回收后立即失去会员权益。", {
        title: "回收付费会员",
        type: "warning",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      });
    } catch (e) {
      // 用户取消
      return;
    }
    let { error, message } = await this.$post("/manager/level/cancel-paid-vip", {
      userId: this.postData.id,
    });
    if (error) return this.$error(message);
    this.$success("回收成功");
    this.getData();
  }

  async adjustAmount() {
    try {
      await this.$dialog({
        title: "调整用户金额",
        props: {
          width: "440px",
        },
        content: () => {
          return <AdjustAmount data={this.postData}></AdjustAmount>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }
    this.$success("调整成功");
    this.getData();
    this.refreshAmountLog();
  }

  /** 余额流水 tab 已经打开过才会存在（lazy），没打开过时首次进入本来就会拉最新数据 */
  refreshAmountLog() {
    let list: any = this.$refs.amountLogList;
    if (list && list.refresh) {
      list.refresh();
    }
  }

  async adjustScore() {
    try {
      await this.$dialog({
        title: "调整用户积分",
        props: {
          width: "440px",
        },
        content: () => {
          return <AdjustScore data={this.postData}></AdjustScore>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }
    this.$success("调整成功");
    this.getData();
    this.refreshScoreLog();
  }

  /** 同上：积分流水 tab 没打开过的话，首次进入本来就会拉最新数据 */
  refreshScoreLog() {
    let list: any = this.$refs.scoreLogList;
    if (list && list.refresh) {
      list.refresh();
    }
  }

  /**
   * 详情页只有一个用户，后端要的是数组，这里就发长度为 1 的。
   * 按钮就在优惠券 tab 里，所以赠完能直接在这个列表上看到结果
   */
  async sendCoupon() {
    let coupon: any;
    try {
      coupon = await this.$dialog({
        title: "赠送优惠券",
        props: {
          width: "900px",
        },
        content: () => {
          return <ChooseCoupon userCount={1}></ChooseCoupon>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }

    let { error, data, message } = await this.$post("/manager/coupon/send", {
      id: coupon.id,
      // id 来自路由 query，是字符串；DTO 声明的是 number[]，这里转掉别指望后端转
      userIds: [Number(this.userId)],
    });
    if (error) return this.$error(message);

    /** 单人赠送失败的原因（如已达该券领取上限）后端也是按人返回的，只有一条 */
    if (data.failCount) {
      let fail = data.failList && data.failList[0];
      return this.$error((fail && fail.message) || "赠送失败");
    }
    this.$success("赠送成功");
    this.refreshCouponList();
  }

  /** 和余额流水同理：tab 是 lazy 的，但按钮就在 tab 内，能点到就说明已经渲染过了 */
  refreshCouponList() {
    let list: any = this.$refs.couponList;
    if (list && list.refresh) {
      list.refresh();
    }
  }

  /**
   * 付费会员和等级没关系（付费等级表里没有 level 字段，是按 sort 排的）。
   * 文案逻辑用户列表也要用，抽到了 @/common/vip
   */
  get paidVipText() {
    /** 详情接口带了 paidLevelInfo，等级名直接从关联上取 */
    return getPaidVipText(this.postData);
  }

  getGender(v) {
    switch (v) {
      case 1:
        return '男'
      case 2:
        return '女'
    }
    return '未知'
  }

  /** 跳到邀请人的详情，用当前路由 path，避免和菜单里配的 path 写死两份 */
  gotoInviter() {
    this.$goto({
      path: this.$route.path,
      query: { id: this.postData.inviterInfo.id },
    });
  }

  /**
   * 这个页面的组件实例不会被重建（下面几个子列表是用 key 重建的，父级不是），
   * 所以同页切到邀请人时只能在这里重新拉一遍用户信息。
   *
   * 必须先比对 path 再拉：跳到订单详情这种别的页面时 query.id 也会变，
   * 只盯 query.id 的话会在组件卸载前拿着对方的 id 去打用户详情接口
   */
  @Watch("$route")
  routeWatcher(to, from) {
    if (to.path != from.path) return;
    this.getData();
  }

  async getData() {
    if (!this.userId) return;
    this.loading = true;
    let { error, data, message } = await this.$post("/manager/user/view", {
      id: this.userId,
    });
    this.loading = false;
    if (error) return this.$error(message);
    this.postData = data;
  }

  created() {
    this.getData();
  }
}
